module.exports = __webpack_public_path__ + "media/images/bricks-bg-f407740676d0461d2e58bf28f5a7f97a.jpg";